import { Outlet } from "react-router-dom";
import AppSidebar from "./AppSidebar";
import AppHeader from "./AppHeader";
import DynamicOgMeta from "./DynamicOgMeta";
import { cn } from "@/lib/utils";

export default function AppLayout() {
  return (
    <div className="brand-page-bg min-h-dvh relative overflow-x-hidden">
      <DynamicOgMeta />
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-28 left-0 h-80 w-80 rounded-full bg-[#dbe9ff] blur-3xl opacity-80" />
        <div className="absolute top-24 right-0 h-72 w-72 rounded-full bg-[#f8efe2] blur-3xl opacity-70" />
        <div className="absolute bottom-8 left-1/3 h-64 w-64 rounded-full bg-[#e6f4ee] blur-3xl opacity-65" />
      </div>
      <AppSidebar />
      <div className={cn(
        "relative z-10 flex min-h-dvh flex-col overflow-hidden transition-all duration-300",
        "md:pl-[122px]"
      )}>
        <AppHeader />
        <main className="flex-1 overflow-y-auto overflow-x-hidden min-w-0 px-3 py-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
        <footer className="px-3 pb-4 pt-2 text-center text-xs text-muted-foreground/50 sm:px-6 lg:px-8">
          © 2026 iChurchData. All rights reserved.
        </footer>
      </div>
    </div>
  );
}
